module.exports = "/_next/static/images/banner_myhomecredit_app-e63b08c76b86340f02fd9e47b91bc10c.svg";